<template>
    <div class="card border-0 team_membermainlisting">
        <div class="sectionclsbodymain tsk_body_right_back">
            <div class="serach_controls_main tsk_controls_main_cls">
                <div class="serach_controls_main_row1">
                    <div class="tsk_top_filter_left">
                        <div class="serach_controls me-2">
                            <SearchSvgIcon />
                            <input type="search" class="formmginput-control tsk_search" id="searchTxtId" placeholder="Search..." v-on:keyup="reloadSearch()">
                        </div>
                        <div class="serach_controlsx w-200 me-2">                    
                            <Select2 v-model="myValue" 
                                v-bind:id="'teamStatusFilterId'"
                                :select=2 
                                :options="$store.state.stausOptions" 
                                :placeholder="'Select Status'"
                                :settings="{ minimumResultsForSearch: -1 }"
                                @change="myChangeEvent($event)" 
                                @select="mySelectEvent($event)"
                            />
                        </div>
                    </div>                   
                    <div class="tsk_top_filter_right">   
                        <AddEditTeam @reload-table-data="reloadSearch" ref="childComponentTeamRef" />
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body p-0">
            <div class="table-responsive pageTblHeightCls " v-if="isResonsiveCls == 1">
                <table class="table table-bordered team_member_list_tsk" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody class="tbodyCls shimmer-wrapper" v-if="$store.state.user.tableLoader === 1">
                        <tr class="text-center " v-for="index in 15" :key="index">
                            <td v-for="index1 in 5" :key="index1">
                                <span class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate"></span>
                            </td>
                        </tr>
                    </tbody>
                    <tbody class="tbodyCls noDATA" v-else-if="$store.state.user.tableLoader === 2">
                        <tr class="text-center">
                            <td colspan="5">
                                <ComponentNoData />
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr v-for="(item) in $store.state.user.teamList" :key="item._id">
                            <td>{{ item.name }}</td>
                            <td>{{ item.email }}</td>
                            <td>{{ item.role }}</td>
                            <td v-if="item.status === true">
                                <div class="form-check form-switch mr-1">
                                    <input class="form-check-input" type="checkbox" role="switch" v-bind:id="buttonId(item._id)" v-bind:dataId="item._id" v-bind:dataVal="item.status" checked="" v-on:click="teamStatusModal(item._id, item.status)">
                                    <label class="form-check-label" v-bind:for="buttonId(item._id)" ></label>
                                </div>
                            </td>
                            <td v-else>
                                <div class="form-check form-switch mr-1">
                                    <input class="form-check-input" type="checkbox" role="switch" v-bind:id="buttonId(item._id)" v-bind:dataId="item._id" v-bind:dataVal="item.status" v-on:click="teamStatusModal(item._id, item.status)">
                                    <label class="form-check-label" v-bind:for="buttonId(item._id)" ></label>
                                </div>
                            </td>
                            <td>
                                <a href="javascript:;" class="cls_action" v-bind:id="item._id" v-on:click="modalEditOpen(item._id)" title="Edit">
                                    <EditSvgIcon />
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="right-bodypart pageTblHeightCls overflow-auto" v-if="isResonsiveCls == 2">
                <div  class="Setcard_row shimmer-wrapper" v-if="$store.state.user.tableLoader === 1">                   
                    <div class="card_ticket_S" v-for="index in 8" :key="index">
                        <div class="topsetheadeTcktr">
                            <label class="d-flex">
                                 <span class="stroke animate title w-100"></span>
                            </label>
                        </div>
                        <div class="card_ticket_body" >
                            <label class="d-flex">
                                <span class="stroke animate title w-50 mb-2"></span>
                                <b class="stroke animate title w-25 mb-2"></b>
                            </label>
                            <label class="d-flex">
                                <span class="stroke animate title w-50 mb-2"></span>
                                <b class="stroke animate title w-25 mb-2"></b>
                            </label>    
                            <label class="d-flex">
                                <span class="stroke animate title w-50 mb-2"></span>
                                <b class="stroke animate title w-25"></b>
                            </label>        
                        </div>
                    </div>                    
                </div>
                <div  class="Setcard_row shimmer-wrapper" v-else-if="$store.state.user.tableLoader === 2">
                    <ComponentNoData />
                </div>
                <div class="Setcard_row" v-else>
                    <div class="card_ticket_S" v-for="(item) in $store.state.user.teamList" :key="item._id">
                        <div class="topsetheadeTcktr">
                            <label class="d-flex">
                                <b>{{ item.role }}</b>
                                <span v-b-tooltip.hover v-bind:title="'View Detail'">
                                    <router-link class="">
                                        <ViewSvgIcon />
                                    </router-link>
                                </span>
                            </label>
                        </div>
                        <div class="card_ticket_body" >
                            <label class="d-flex">
                                <span>Name</span>
                                <b>{{ item.name }}</b>
                            </label>                         
                            <label class="d-flex" v-if="item.status === true">
                                <span>Status</span>
                                <b>
                                    <div class="form-check form-switch mr-1">
                                        <input class="form-check-input" type="checkbox" role="switch" v-bind:id="buttonId(item._id)" v-bind:dataId="item._id" v-bind:dataVal="item.status" checked="" v-on:click="teamStatusModal(item._id, item.status)">
                                        <label class="form-check-label" v-bind:for="buttonId(item._id)" ></label>
                                    </div>
                                </b>
                            </label> 
                            <label class="d-flex" v-else>
                                <span>Status</span>
                                <b>
                                    <div class="form-check form-switch mr-1">
                                        <input class="form-check-input" type="checkbox" role="switch" v-bind:id="buttonId(item._id)" v-bind:dataId="item._id" v-bind:dataVal="item.status" v-on:click="teamStatusModal(item._id, item.status)">
                                        <label class="form-check-label" v-bind:for="buttonId(item._id)" ></label>
                                    </div>
                                </b>
                            </label> 
                            <label class="d-flex">
                                <span>Email</span>
                                <b>{{ item.email }}</b>
                            </label> 
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex px-3 databottom justify-content-between align-content-center" v-if="$store.state.user.tableLoader == 3">
                <p v-if="page * pageLength > $store.state.user.totalRecord">Showing {{ formatMoney((page * pageLength) - pageLength + 1) }} to {{
                    formatMoney($store.state.user.totalRecord) }} of {{ formatMoney($store.state.user.totalRecord) }} entries</p>
                <p v-else>Showing {{ formatMoney((page * pageLength) - pageLength + 1) }} to {{ formatMoney(page * pageLength) }} of {{
                    formatMoney($store.state.user.totalRecord) }} entries</p>
                <vs-pagination :total="$store.state.user.totalLenght" :max="8" v-model="page" @click="reloadPagination(page)"></vs-pagination>
            </div>
        </div>
    </div>
    <input type="hidden" class="teamValId" id="teamValId"/>
    <input type="hidden" class="teamStatusId" id="teamStatusId"/>
    <RoleData />
</template>
<script>
import SearchSvgIcon from '@/components/Widgets/Icon/SearchSvgIcon.vue';
import ComponentNoData from '@/components/Widgets/Icon/ComponentNoData.vue';
import AddEditTeam from './AddEditTeam.vue';
import EditSvgIcon from '@/components/Widgets/Icon/EditSvgIcon.vue';
import Select2 from 'vue3-select2-component';
import RoleData from '../role/RoleData.vue';
import ViewSvgIcon from '@/components/Widgets/Icon/ViewSvgIcon.vue';
import $ from "jquery";
import {
    ref
} from 'vue';
import {
    formatMoney
} from '../../../helper'
import axios from 'axios'
    export default {
        name: 'TeamMemberListingPage',
        components: {
            Select2,
            SearchSvgIcon,
            ComponentNoData,
            EditSvgIcon,
            RoleData,
            AddEditTeam,
            ViewSvgIcon
        },
        data() {
            return {
                currentx: 5,
                page: 1,
                pageLength: this.$store.state.showEntries,
                searchKey: '',
                teamList: [],
                myValue: 'true',
                taskMainListHeight: 0,
                windowWidth: window.innerWidth,
                isResonsiveCls: 1,
            }
        },
        async mounted() {
            this.$store.state.pageTitle = 'Team Member'
            this.$store.state.isAdmin = 2
            if(this.windowWidth < 991){
                this.isResonsiveCls = 2;
            }
            $('tbody').height(this.$store.state.tbody);
            $('.pageTblHeightCls').height(this.$store.state.pageTblHeightCls);
            if (this.$store.state.isActiveToken != '1') {
                // console.log(this.currentDate);
            } else {
                await this.loadTeamData();
            }
            let temps = this
            $("body").on("click", '#searchTxtId', function () {
                if ($('#searchTxtId').val() != '') {
                    $('#searchTxtId').val('');
                    this.searchKey = '';
                    this.page = 1;
                    temps.reloadSearch()
                }
            });
            this.onResize();
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },
        computed: {
            iAT() {
                return this.$store.state.user.role_id
            },
        },
        watch: {
            async iAT(newValue) {
                if (this.$store.state.user.role_id != '') {
                    await this.loadTeamData();
                }
                return newValue
            },
        },
        methods: {
            formatMoney,
            buttonId(id) {
                return "team" + id;
            },
            startLoader () {
                this.$Progress.start()
            },
            finishLoader () {
                this.$Progress.finish()
            },
            async teamStatusModal(_id, status) {
                document.getElementById('teamStatusId').value = status
                document.getElementById('teamValId').value = _id
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Confirm`,
                    text: 'Are you sure you want to update status?',
                    accept: this.teamStatusChange,
                    cancel: this.teamStatusCloseChange
                })
            },
            async teamStatusCloseChange() {
                // const teamStatusId = document.getElementById('teamStatusId').value
                let teamValId = document.getElementById('teamValId').value
                let teamValIdsds = true;
                if (teamValId === 'false') {
                    teamValIdsds = false;
                }
                document.getElementById("team" + teamValId).checked = teamValIdsds;
            },
            async teamStatusChange() {
                this.formLoader = 2
                const teamStatusId = document.getElementById('teamStatusId').value
                let teamValId = document.getElementById('teamValId').value
                let teamValIdsds = false;
                if (teamStatusId === 'false') {
                    teamValIdsds = true;
                }
                this.startLoader() 
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                await axios.post(process.env.VUE_APP_API_URL + 'user/status-update', {
                    status: teamValIdsds,
                    team_id: teamValId,
                })
                    .then((resp) => {
                        if (resp.status == 200 && resp.data.status == 'success') {
                            this.$toast.success(resp.data.message);
                            this.loadTeamData();
                        } else if (resp.status == 200 && resp.data.status == 'failure') {
                            this.errorMessage = resp.data.data;
                            this.errorRes = resp.data.message;
                        }
                        this.formLoader = 1
                        this.finishLoader()
                    })
                    .catch(error => {
                        this.errorMessage = error.message;
                        console.error("There was an error!", error);
                        console.log("response", error.response.status);
                        console.log("message", error.response.data.message);
                        this.errorRes = error.response.data.message;
                        this.formLoader = 1
                    })
            },
            async reloadPagination(itemObjKey) {
                if (itemObjKey > 0 && itemObjKey !== -1 && itemObjKey <= this.$store.state.user.totalLenght) {
                    this.page = itemObjKey;
                    this.loadTeamData();
                }
            },
            myChangeEvent(val) {
                this.myValueRole = val
                this.loadTeamData();
            },
            mySelectEvent({ id, text }) {
                console.log({ id, text })
                this.page = 1;
                this.loadTeamData();
            },
            async reloadSearch() {
                const searchCls = document.getElementById('searchTxtId').value;
                this.searchKey = searchCls.trim();
                this.page = 1;
                this.loadTeamData();
            },
            async loadTeamData() {
                if (this.$store.state.user.teamList.length > 0) {
                    // this.$store.state.customer.tableLoader = 3
                } else {
                    this.$store.state.user.tableLoader = 1
                }
                let token = localStorage.getItem('supportSystemAdmin');
                if (!token) {
                    this.$store.state.user.accessToken = ''
                }
                let teamStatusFilterId = document.getElementById('teamStatusFilterId').value
                let status = teamStatusFilterId;
                this.startLoader() 
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                await axios.get(process.env.VUE_APP_API_URL + 'user/list', {
                        params: {
                            page: this.page,
                            pageLength: this.pageLength,
                            searchKey: this.searchKey,
                            status: status,
                        }
                    })
                    .then((resp) => {
                        if (resp.status == 200 && resp.data.status == 'success') {
                            this.teamList = []
                            this.teamList = resp.data.data.records
                            this.totalRecord = resp.data.data.totalRecord
                            this.totalLenght = this.totalRecord / this.pageLength
                            this.totalLenght = Math.ceil(this.totalLenght);

                            this.$store.state.user.teamList = resp.data.data.records;
                            this.$store.state.user.totalLenght = this.totalLenght;
                            this.$store.state.user.totalRecord = this.totalRecord;

                            if (this.$store.state.user.teamList.length > 0) {
                                this.$store.state.user.tableLoader = 3
                            } else {
                                this.$store.state.user.tableLoader = 2
                            }
                            setTimeout(async () =>
                                this.onResize(),
                            100);
                        }else{
                            this.$store.state.user.accessToken = ''
                            this.$store.state.isActiveToken = ''
                            this.$store.state.user.userInfo = ''
                            this.$store.state.isAdmin = 2 
                            localStorage.removeItem("supportSystemAdmin");
                            this.$router.push({
                                path: '/login'
                            })
                        }
                        this.finishLoader() 
                    })
                    .catch(error => {
                        console.error("There was an error!", error);
                        console.log("response", error.response.status);
                        console.log("message", error.response.data.message);
                        // this.errorRes = error.response.data.message;
                    })
            },
            async modalEditOpen(team_id) {
                $('.teamValId').val(team_id);
                this.callChildTeamMethod();
            },
            onResize() {
                this.windowWidth = window.innerWidth
                this.windowHeight = window.innerHeight

                var headNavCls = $('.headNavCls').outerHeight() || 0;
                var tsk_controls_main_cls = $('.tsk_controls_main_cls').outerHeight() || 0;
                var thead = $('thead').outerHeight() || 0;
                var databottom = $('.databottom').outerHeight() || 0;

                var cntSubvar = headNavCls + tsk_controls_main_cls + thead + databottom
                var tabHei = headNavCls + tsk_controls_main_cls + databottom
                var cntSubvar1 = this.windowHeight - cntSubvar
                tabHei = this.windowHeight - tabHei
                this.taskMainListHeight = tabHei;
                this.$store.state.tbody = cntSubvar1
                $('tbody').height(this.$store.state.tbody);
                if(this.isResonsiveCls == 2){
                    tabHei = tabHei-20
                }
                this.$store.state.pageTblHeightCls = tabHei
                $('.pageTblHeightCls').height(this.$store.state.pageTblHeightCls);
                this.checkHeightScroll();
            },
            checkHeightScroll() {
                $('.table').removeClass('ScrollAddedCls');
                if (this.hasScrollBar() == true) {
                    $('.table').addClass('ScrollAddedCls');
                }
            },
            hasScrollBar() {
                if ($(".tbodyCls")[0]) {
                    return $('.tbodyCls').get(0).scrollHeight > $('.tbodyCls').height() + 10;
                } else {
                    return false;
                }
            },
        },
        setup() {
            const childComponentTeamRef = ref(null);
            const callChildTeamMethod = () => {
                if (childComponentTeamRef.value) {
                    childComponentTeamRef.value.modalEditOpen();
                }
            };
            return {
                childComponentTeamRef,
                callChildTeamMethod,
            };
        },
    }
</script>